import { Component, OnInit, OnDestroy, ViewChild, Renderer2, ElementRef, ChangeDetectorRef, NgZone } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormsModule } from '@angular/forms';
import { PostSlackService } from '../../services/post-slack.service';
import { PostValidationService } from '../../services/post-validation.service';
import { PostSpeiService } from '../../services/post-spei.service';
import { PostStripeService } from '../../services/post-stripe.service';
import { RfcModalService } from '../../services/rfc-modal.service';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatStepper } from '@angular/material/stepper';
import { Observable, of } from 'rxjs';
import { NotifierService } from "angular-notifier";
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { loadStripe } from '@stripe/stripe-js/pure';
import { ActivatedRoute } from '@angular/router';
import { CookiesService } from '../../services/cookies.service';
import { Subscription } from 'rxjs';
import { REGIMEN_LIST, PIPEDRIVE_REFERENCE, LINE_OF_BUSINESS_LIST } from './list.data';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { UserService } from './users.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { IPlanInfo } from 'src/app/interfaces/plan-info.interface';
import { PlanService } from 'src/app/services/plan.service';
import { Location } from '@angular/common';
import { debounceTime, take, catchError } from 'rxjs/operators';
import { CheckIdService } from '../../services/check-id.service';
import { timeout } from 'rxjs/operators';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { SendFormContactService } from 'src/app/services/send-form-contact.service';
import { DataLayerService } from 'src/app/services/data-layer.service';
import { SHA256 } from 'crypto-js';

declare const fbq: any;
declare const oaiq: any;

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: false },
    },
  ]
})
export class UsersComponent implements OnInit, OnDestroy {
  _env: string = this.env._env;
  @ViewChild('phone') phoneElement!: ElementRef;
  @ViewChild('email') emailElement!: ElementRef;
  @ViewChild('rfc') rfcElement!: ElementRef;
  @ViewChild('postal_code') postalCodeElement!: ElementRef;
  @ViewChild('type_plan') typePlanElement!: ElementRef<HTMLDivElement>;
  @ViewChild('title_plan') titlePlanElement!: ElementRef<HTMLDivElement>;
  @ViewChild('description_plan_info') descriptionPlanInfoElement!: ElementRef<HTMLDivElement>;
  @ViewChild('list_features_plan') listFeaturesPlanElement!: ElementRef<HTMLUListElement>;
  @ViewChild('testimonial_div') testimonialElement!: ElementRef<HTMLDivElement>

  // // TOTALS
  @ViewChild('totals_block_one_label_subtotal') totalsBlockOneLabelSubtotal!: ElementRef<HTMLLabelElement>;
  @ViewChild('totals_block_one_value_subtotal') totalsBlockOneValueSubtotal!: ElementRef<HTMLLabelElement>;

  // PAYMENT_PLANS
  @ViewChild('inputAnual') inputAnual!: ElementRef<HTMLInputElement>;
  @ViewChild('inputMensual') inputMensual!: ElementRef<HTMLInputElement>;

  // NUMERO DE USUARIOS CUANDO SEA MICHOACAN
  @ViewChild('number_of_users') numberOfUsersRef!: ElementRef<HTMLInputElement>;

  @ViewChild(MatStepper) stepper: MatStepper;

  readonly signupStepLabels = [
    'Usuarios y Planes',
    'Información de Registro',
    'Método de Pago',
    'Información de Pago',
    'Pago',
    '¡Listo!'
  ];

  public is_valid: boolean = true;
  private readonly notifier: NotifierService;
  disabled_button: boolean = false;
  isRegimensFiscal: boolean = true;
  isQa: boolean = false;
  private static readonly GTM_CONTACT_STORAGE_CLEAR_MS = 2500;
  private static readonly GTM_FORM_EMAIL_KEY = 'form_email';
  private static readonly GTM_FORM_PHONE_KEY = 'phone';
  private static readonly GTM_FORM_NAME_KEY = 'form_name';
  private gtmContactStorageClearHandle: number | null = null;

  constructor(
    public PostSlack: PostSlackService,
    public PostValidation: PostValidationService,
    public PostSpei: PostSpeiService,
    public PostStripe: PostStripeService,
    notifierService: NotifierService,
    private router: Router,
    private _formBuilder: FormBuilder,
    private cookiesService: CookiesService,
    private renderer: Renderer2,
    private userService: UserService,
    private env: EnvironmentService,
    private rfcModalService: RfcModalService,
    private sweetAlert: SweetAlertService,
    private route: ActivatedRoute,
    private planService: PlanService,
    private cdRef: ChangeDetectorRef,
    private zone: NgZone,
    private location: Location,
    private checkIdService: CheckIdService,
    private sendFormContactService: SendFormContactService,
    private dataLayerService: DataLayerService,

  ) {
    this.notifier = notifierService;
  }

  isLoading: boolean = false;
  emailCodeCorrect: boolean = false;
  fieldTextType: boolean = false;
  slack_submitted: boolean = false;
  url_path: string = window.location.href;
  plans: any[] = [];
  regimenList: any = null;
  lineOfBusinessList: any = null;
  fuenteList: any = null;
  pipedriveReferenceList: any = null;
  check_company: Promise<any> = null;
  checkCompany: Promise<any> = null;
  stepOneCompleted: boolean = false;
  planSelectionReady = false;
  stepTwoCompleted: boolean = false;
  stepThreeCompleted: boolean = false;
  invoicingChecked: boolean = true;
  selectedPlan: string = null;
  selectedRecurrence: string = null;
  selectedRegimenName: string = null;
  selectedRegimen: string = null;
  selectLineOfBusinessId: string = null;
  posthog_id: string = null;
  selectedFuenteName: string = null;
  selectedFuente: string = null;
  totalSale: string = "0.00";
  totalDiscount: string = "0.00";
  slackResult: Observable<any>;
  stripeResult: Observable<any>;
  slackError: string;
  stripeError: string;
  textToolTipPhone = "10 dígitos sólo números"
  textToolTipRFC = "El formato del RFC debe ser correcto, no usar minúsculas ni espacios"
  textToolTipMail = "El correo debe tener un formato valido"
  textToolTipPassword = "El password debe estar formado por al menos 6 caracteres"
  textToolTipCP = "El código postal debe estar formado por 5 dígitos"
  textToolTipRegimen = "El régimen fiscal es obligatorio"
  textToolTipFuente = "Este campo es obligatorio"
  titleLastStep: string = "Falta poco";
  textLastStep: string = "Procesando...";
  paymentMethod: string = null;
  precio_deal: any = null;
  descuento_deal: any = null;
  isMobile: any = false;
  hashSession: string;
  half_off_discount: number = 0; // 0
  welcome_discount: number = 0;
  welcome_discount_amount: number = 0;
  discount_message: string = "";
  discount_referres_message: string = "";
  spei_data: any;
  obAgentName: string;
  obAgentEmail: string;
  obAgentPhone: string;
  plan_discount: number = 0;
  // Stripe
  elements: any;
  stripe: any;
  stripe_api_key: string;
  stripe_secret_key: string;
  client_secret: string;
  COOKIES_EXPIRATON_DAYS = 365

  // Cookies
  utm_medium: string;
  utm_source: string;
  utm_campaign: string;
  utm_term: string;
  utm_content: string;
  fbclid: string;
  gclid: string;
  ttclid: string;
  utm_id: string;
  version: string;
  ad_set: string;
  first_utm: string;
  first_visit_date: string;
  lite_code: any;
  liteInfo: any;
  referredInfo: any;
  is_lite: any = false;
  referred_id: any;
  private routeSub: Subscription;
  referredName: any = "alguien"
  referredEmail: any = ""
  isBrandAmbassador: boolean = false;

  // TotalPrices
  type_plan_select: any
  formatter: any
  default_plan: any;
  selectedPlanOption: string = '';
  selectedPaymentOption: string = '';

  //ThankYouPage
  shouldCelebrate: Boolean = false;
  pageTitle: string | undefined;
  pageSubtitle: string | undefined;
  showPendiente: boolean = false;
  showExitoso: boolean = false;
  showError: boolean = false;
  showLite: boolean = false;
  planName: string | undefined;
  cardInputs: boolean = false;
  pay: boolean = false;
  paymentElement: any;

  // * Control
  acceptedTyC: boolean = false

  get isCreateAccountEnabled(): boolean {
    if (this.processingPayment || !this.secondFormGroup) { return false; }
    if (this.registrationHoldSnapshot && this.registrationHoldSnapshot === this.currentFormSnapshot()) {
      return false;
    }
    return this.userService.validateAllFields(
      this.secondFormGroup, this.selectedRegimen, this.acceptedTyC
    ).status === true;
  }
  acceptedPromotionalEmail: boolean = true;

  // STATES FROM IP
  stateName: string = 'Other';

  // FREE TRIAL
  free_trial = false;

  // * Plan Info
  planInformation: IPlanInfo;
  plansInterface: IPlanInfo[] = [];
  pipedriveReference: string = '';

  // PROCESSING PAYMENT FLAG
  processingPayment: boolean = false;
  // Tras un code != ok, el botón se mantiene apagado hasta que el formulario cambie
  registrationHoldSnapshot: string = null;

  isUserAcademy: boolean = false;

  /* stepper */
  public firstFormGroup: FormGroup = new FormGroup({
  })

  //secondFormGroup: FormGroup;
  public secondFormGroup: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
    phone: new FormControl('', [Validators.required, Validators.nullValidator]),
    email: new FormControl('', [Validators.required, Validators.nullValidator]),
    username: new FormControl('', [Validators.required, Validators.nullValidator]),
    userpass: new FormControl('', [Validators.required, Validators.pattern("^.{6,}$")]),
    company: new FormControl('', [Validators.required, Validators.nullValidator]),
    rfc: new FormControl('', [Validators.required, Validators.nullValidator]),
    company_invoicing: new FormControl('', [Validators.required, Validators.nullValidator]),
    rfc_invoicing: new FormControl('', [Validators.required, Validators.nullValidator]),
    use_same_data_for_invoicing: new FormControl('', [Validators.required, Validators.nullValidator]),
    regimen_fiscal: new FormControl('', [Validators.required, Validators.nullValidator]),
    fuente: new FormControl('', [Validators.required, Validators.nullValidator]),
    postal_code: new FormControl('', [Validators.required, Validators.nullValidator]),
  })

  /* stepper */

  /* PUBLIC METHODS */

  async ngAfterViewInit(): Promise<void> {
    try {
      const result = await this.userService.allPlans();
      const plansArray = this.planService.normalizeRawPlans(result);

      if (!plansArray.length) {
        console.error('No plans returned from API', result);
        return;
      }

      this.plans = plansArray;
      this.default_plan = plansArray.find(plan => plan.landing_freemium_default_plan == true) || plansArray[0];
      this.plansInterface = this.planService.getPlans(plansArray, this.referred_id ? true : false);
      this.planInformation = this.planService.resolveInitialPlan(this.plansInterface);

      if (!this.planInformation) {
        console.error('Could not resolve initial plan from API data');
        return;
      }

      this.selectedPlan = String(this.planInformation.id);
      this.selectedRecurrence = String(this.planInformation.recurrence);
      this.selectedPlanOption = (this.planInformation.plan_short_name || '').toLowerCase();
      this.selectedPaymentOption = this.planService.getRecurrenceLabel(this.planInformation.recurrence).toLowerCase();
    } catch (error) {
      console.error('Failed to load plans', error);
    }
  }

  async ngOnInit() {
    // Cookies
    this.routeSub = this.route.params.subscribe(params => {
      this.referred_id = params['id']

      // if (params['promoId'] === 'yucatan') {
      //   this.cookiesService.createCookie('ipLocation', 'Yucatán', 30);
      // }
      // if (params['promoId'] === 'michoacan') {
      //   this.cookiesService.createCookie('ipLocation', 'Michoacán', 30);
      // }

      this.location.replaceState('/');
    });

    this.saveAttributionCookiesFromParams()

    this.referredInfo = await this.userService.getReferredInfo(this.referred_id);

    if (this.referredInfo["referred_info"].error) {
      this.router.navigate(['/']);
    }

    this.referredName = this.referredInfo["referred_info"].name;
    this.referredEmail = this.referredInfo["referred_info"].email;
    this.isBrandAmbassador = !!this.referredInfo["referred_info"]?.is_brand_ambassador;

    // Fill cookies variables
    this.assignCookieVariables();

    // Logs
    this.hashSession = this.userService.makeHashSession();
    this.userService.addLogTransaction("landing_page/" + this.cookiesService.readCookie('ipLocation'), null, this.hashSession);
    this.mobileCheck();

    if (this.isMobile) this.userService.addLogTransaction("mobile_version", null, this.hashSession);

    // Fill lists to quoter
    this.regimenList = REGIMEN_LIST;
    this.lineOfBusinessList = LINE_OF_BUSINESS_LIST;

    // this.fuenteList = FUENTE_LIST;
    this.pipedriveReferenceList = PIPEDRIVE_REFERENCE;

    this.secondFormGroup.get('username').disable();
    // Validate the username and password fields when in lite mode
    this.validateUserAndPasswordInLite();

    // Assign the Stripe API key based on the current environment
    this.assignStripeApiKeyFromEnvironment();

    // LandingStepOne: El usuario entra al landing y ve los planes disponibles
    this.userService.addMixPanelEvent('LandingStepOne', { status: 'ok' });

    // Assign stepper styles
    this.assignStepperStyles();

    // init value set
    this.signupForm.get('users_number').setValue(1);

    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required],
    });

    this.secondFormGroup = this.buildSecondFormGroup();
    const postalCodeControl = document.getElementById('postal_code') as HTMLInputElement;
    const razonSocialControl = document.getElementById('company') as HTMLInputElement;
    const regimen_fiscal = document.getElementById('regimen_fiscal') as HTMLSelectElement;
/*
    this.secondFormGroup.get('rfc')?.valueChanges
      .pipe(debounceTime(1500)) // 1.5 segundos
      .subscribe(value => {
        this.checkIdToMetaData(value);
      });*/
    
    // TODO: Cambiar a prod cuando se vaya a liberar checkId a produccion 
    if (this.env._env == 'stg') {
      postalCodeControl.disabled = true;
      razonSocialControl.disabled = true;
      regimen_fiscal.disabled = true;

      this.secondFormGroup.get('rfc')?.valueChanges
        .pipe(debounceTime(1500)) // 1.5 segundos
        .subscribe(value => {
          this.autoFillFields(value);
        });
    } else {
      postalCodeControl.removeAttribute('disabled');
      razonSocialControl.removeAttribute('disabled');
      regimen_fiscal.removeAttribute('disabled');
    }
  }

  async autoFillFields(rfc: string) {
    // Si el RFC es válido y tiene más de 11 caracteres, se procede a buscar la información
    if (rfc && rfc.length > 11) {
      // PUBLICO EN GENERAL
      if (rfc === 'XAXX010101000') { return this.sweetAlert.showAlertGenericRFC(); return; }

      this.isLoading = true;
      await this.checkIdService.getRfcInformation(rfc).pipe(
        take(1),
        timeout(20000)
      ).subscribe({
        next: (response) => {
          let status = response['checkId']['exitoso'];

          if (!status) {
            this.handleRfcNotFound();
            return;
          }

          let data = response['checkId']['resultado'];
          const postalCode = data['codigoPostal']['codigoPostal'];
          const razonSocial = data['rfc']['razonSocial'];
          const regimenesFiscales = data['regimenFiscal']['regimenesFiscales'];

          this.regimenList = [...regimenesFiscales.matchAll(/(\d{3}) - (.*?)(?=,\d{3} - |$)/g)].map(match => ({
            id: match[1],
            value: match[2].trim()
          }));

          this.secondFormGroup.patchValue({
            company: razonSocial,
            postal_code: postalCode,
          });

          const selectEl = document.getElementById('regimen_fiscal') as HTMLSelectElement;
          if (this.regimenList.length === 1) {
            this.isRegimensFiscal = true;
            const unicoRegimenId = this.regimenList[0].id;
            this.selectedRegimen = unicoRegimenId;
            this.selectedRegimenName = this.regimenList[0].value;
            this.secondFormGroup.patchValue({
              regimen_fiscal: unicoRegimenId
            });

            setTimeout(() => {
              if (selectEl) selectEl.value = unicoRegimenId;
            });
          } else {
            selectEl.removeAttribute('disabled');
          }
          this.isLoading = false;
        },
        error: (error) => {
          // MOSTRAR MODAL
          this.handleRfcNotFound();
        }
      });
    }
  }

  private handleRfcNotFound(): void {
    const postalCodeControl = document.getElementById('postal_code') as HTMLInputElement;
    const razonSocialControl = document.getElementById('company') as HTMLInputElement;
    const regimen_fiscal = document.getElementById('regimen_fiscal') as HTMLSelectElement;

    this.isLoading = false;
    this.showRfcNonFoundModal();
    this.secondFormGroup.get('rfc').setValue('');
    this.secondFormGroup.get('company').setValue('');
    this.secondFormGroup.get('postal_code').setValue('');

    postalCodeControl.disabled = true;
    razonSocialControl.disabled = true;
    regimen_fiscal.disabled = true;

    this.stepTwoReadMode(false);
  }

  private showAlertFieldsError(fields: string[]): void {
    this.sweetAlert.showErrorFieldsAlert(
      fields
    );
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  public signupForm: FormGroup = new FormGroup({
    type_plan: new FormControl('', [Validators.required, Validators.nullValidator]),
    users_number: new FormControl('', [Validators.required, Validators.nullValidator])
  })


  //private auth: AuthService, private crud: CRUDService, private stripePmService: StripePmService,
  onCapture(field) {
    if (field == 'company') {
      this.seeStepTwoDownForm()
    }
    // Validate form inputs
    this.validateSecondFormInputs(field);
    if (field === 'name' || field === 'email' || field === 'phone') {
      this.syncGtmContactLocalStorageFromForm();
    }
    // Si los datos de facturación estan apagados entonces replicar rfc y razón social
    this.secondFormGroup.get('rfc_invoicing').setValue(this.secondFormGroup.get('rfc').value);
    this.secondFormGroup.get('company_invoicing').setValue(this.secondFormGroup.get('company').value);

    if (this.secondFormGroup.get('name').invalid || this.secondFormGroup.get('phone').invalid || this.secondFormGroup.get('email').invalid
      || this.secondFormGroup.get('company').invalid || this.secondFormGroup.get('rfc').invalid ||
      this.secondFormGroup.get('postal_code').invalid || this.selectedRegimen == null || this.selectedFuente == null ||
      this.selectLineOfBusinessId == null ||
      // this.pipedriveReference == null ||
      this.secondFormGroup.get('rfc_invoicing').invalid || this.secondFormGroup.get('company_invoicing').invalid) {

      this.stepTwoCompleted = false;
    } else {
      this.stepTwoCompleted = true;
      this.seeStepTwoNextButton()
    }
  }

  onChangeRegimen() {
    let e = (document.getElementById("regimen_fiscal")) as HTMLSelectElement;
    if (e == null) {
      return;
    }
    this.selectedRegimen = e.options[e.selectedIndex].dataset.id;
    this.selectedRegimenName = e.options[e.selectedIndex].dataset.value;
    this.onCapture("regimen_fiscal");
  }

  onChangeLineOfBusiness() {
    let e = (document.getElementById("line_of_business")) as HTMLSelectElement;
    if (e == null) return;

    this.selectLineOfBusinessId = e.options[e.selectedIndex].dataset.id;
    this.secondFormGroup.addControl('line_of_business',
      new FormControl(this.selectLineOfBusinessId));
    this.onCapture("line_of_business");
  }

  onChangePipedriveReference(): void {
    let e = (document.getElementById("pipedrive_reference")) as HTMLSelectElement;
    if (e == null) return;

    this.pipedriveReference = e.options[e.selectedIndex].dataset.id;
    this.secondFormGroup.addControl('pipedrive_reference',
      new FormControl(this.pipedriveReference));
  }

  async MichoacanPostSlack(): Promise<void> {
    this.processingPayment = true;
    let validateAllFieldsJSON = this.userService.validateAllFields(
      this.secondFormGroup, this.selectedRegimen, this.acceptedTyC,
      true // IS MICHOACAN
    )

    // VALIDAR CAMPOS PARA FORMULARIO DE MICHOACAN
    if (validateAllFieldsJSON.message === undefined) { validateAllFieldsJSON.message = ''; }
    validateAllFieldsJSON.message += this.validatePipedriveReference();
    if (this.stateName === 'Michoacán') validateAllFieldsJSON.message += this.validateLineOfBusiness();
    if (validateAllFieldsJSON.message !== '') { validateAllFieldsJSON.status = false; }


    if (!validateAllFieldsJSON.status) {
      this.userService.addLogTransaction("form_validation " + validateAllFieldsJSON.message, null, this.hashSession);
      alert(validateAllFieldsJSON.message)
      this.processingPayment = false;
      return null;
    }
    // NUMERO DE USUARIOS SIEMPRE SERA 1 CUANDO ES MICHOACAN
    this.zone.run(() => {
      this.planInformation.number_of_users = 1;
    });

    this.planInformation.potential_user_number = Number(this.numberOfUsersRef.nativeElement.value);

    this.free_trial = true;
    let data = this.fillDataValues();
    await this.submitCreateAccountMichoacan(data);
  }

  private async submitCreateAccountMichoacan(data: any): Promise<void> {
    try {
      const validation = await this.PostValidation.postContalinkValidation(data).toPromise();

      if (validation && validation.code === 'ok') {
        this.applyRehireFlagToSlackPayload(data, validation);
        await this.postSlackMichoacan(data);
        return;
      }

      const reason = (validation && validation.code) ? validation.code : 'validation_failed';
      await this.blockRegistrationAttempt(data, reason);
      this.holdCreateAccountUntilFormChanges();
    } catch (error) {
      console.error('Error al crear cuenta:', error);
      this.enableCreateAccountButton();
    }
  }

  private validatePipedriveReference(): string {
    if (this.pipedriveReference === null || this.pipedriveReference === '') {
      return '- Cómo escucho de nosotros?';
    }
    return '';
  }

  private validateLineOfBusiness(): string {
    if (this.selectLineOfBusinessId === null || this.selectLineOfBusinessId === '') {
      return '\n- Giro de tu negocio';
    }
    return '';
  }

  onChange() {
    this.type_plan_select = (document.getElementById("type_plan")) as HTMLSelectElement;
    if (this.type_plan_select == null) {
      return;
    }
    const selected_plan = this.type_plan_select.options[this.type_plan_select.selectedIndex].dataset;
    this.selectedPlan = this.type_plan_select.options[this.type_plan_select.selectedIndex].dataset.planid;
    this.selectedRecurrence = this.type_plan_select.options[this.type_plan_select.selectedIndex].dataset.recurrence;

    // this.assignTotalPrice2();
  }

  async changeSizeFromScreen() {
    const testimonialDiv = document.getElementById('testimonial-div');
    const cardsDiv = document.getElementById('cards-div');

    if (window.innerWidth >= 1750) {
      testimonialDiv.classList.remove('col-lg-offset-2');
      testimonialDiv.classList.add('col-lg-offset-1');

      cardsDiv.classList.remove('col-lg-offset-1');
      cardsDiv.classList.add('col-lg-offset-2');
    }
  }

  async goStepTwo() {
    if (!this.planSelectionReady && this.stateName !== 'Michoacán') return;
    let testElements = Array.from(document.getElementsByClassName('whatsapp-pin') as HTMLCollectionOf<HTMLElement>)
    testElements.forEach((element) => { element.style.display = 'none'; });

    if (this.lite_code != null && this.lite_code != undefined) {
      // Lite Obtener y cargar información disponible.
      this.is_lite = true;
      this.liteInfo = await this.userService.getLiteInfo(this.lite_code);
      this.secondFormGroup.get('name').setValue(this.liteInfo["lite_info"]["name"]);
      this.secondFormGroup.get('phone').setValue(this.liteInfo["lite_info"]["phone"]);
      this.secondFormGroup.get('email').setValue(this.liteInfo["lite_info"]["email"]);
      this.secondFormGroup.get('userpass').setValue(this.liteInfo["lite_info"]["email"]);
      this.secondFormGroup.get('company').setValue(this.liteInfo["lite_info"]["razon_social"]);
      this.secondFormGroup.get('rfc').setValue(this.liteInfo["lite_info"]["rfc"]);
      this.secondFormGroup.get('rfc_invoicing').setValue(this.liteInfo["lite_info"]["rfc"]);
      this.secondFormGroup.get('company_invoicing').setValue(this.liteInfo["lite_info"]["razon_social"]);
      this.secondFormGroup.get('username').setValue(this.liteInfo["lite_info"]["email"]);

    }

    this.userService.addLogTransaction("load_info_form " + this.planInformation.plan_short_name, null, this.hashSession);
    this.userService.addMixPanelEvent('LandingStepTwo', { status: 'ok', plan: this.planInformation.plan_short_name });

    this.stepper.next();
    this.stepper.linear = true;
  }

  stepTwoReadMode(check) {
    // TODO HABILIDAR CUANDO cHeck SEA FALSO
    if (check) {
      this.signupForm.get('users_number').disable()
      this.signupForm.get('type_plan').disable()
      this.secondFormGroup.get('name').disable();
      this.secondFormGroup.get('phone').disable();
      this.secondFormGroup.get('email').disable();
      this.secondFormGroup.get('userpass').disable();
      this.secondFormGroup.get('company').disable();
      this.secondFormGroup.get('rfc').disable();
      this.secondFormGroup.get('postal_code').disable();
      this.secondFormGroup.get('rfc_invoicing').disable();
      this.secondFormGroup.get('regimen_fiscal').disable();
      this.secondFormGroup.get('fuente').disable();
      this.secondFormGroup.get('company_invoicing').disable();
    } else {
      this.signupForm.get('users_number').enable()
      this.signupForm.get('type_plan').enable()
      this.secondFormGroup.get('name').enable();
      this.secondFormGroup.get('phone').enable();
      this.secondFormGroup.get('email').enable();
      this.secondFormGroup.get('userpass').enable();
      // this.secondFormGroup.get('company').enable();
      this.secondFormGroup.get('rfc').enable();
      // this.secondFormGroup.get('postal_code').enable();
      this.secondFormGroup.get('rfc_invoicing').enable();
      // this.secondFormGroup.get('regimen_fiscal').enable();
      this.secondFormGroup.get('fuente').enable();
      this.secondFormGroup.get('company_invoicing').enable();
    }
  }

  async sendData(stepper: MatStepper) {
    if (this.processingPayment) { return null; }
    this.processingPayment = true;

    try {
      let validateAllFieldsJSON = this.userService.validateAllFields(
        this.secondFormGroup, this.selectedRegimen, this.acceptedTyC
      )

      if (!validateAllFieldsJSON.status) {
        this.userService.addLogTransaction("form_validation " + validateAllFieldsJSON.message, null, this.hashSession);
        this.showAlertFieldsError(validateAllFieldsJSON.errors);
        // alert(validateAllFieldsJSON.message)
        this.processingPayment = false;
        return null;
      }

      if (this.slack_submitted) {
        stepper.next()
        this.processingPayment = false;
        return null;
      }

      this.slack_submitted = true
      this.stepTwoReadMode(true)

      let data = this.fillDataValues();
      await this.submitCreateAccount(data, stepper);
    } catch (error) {
      console.error('Error al crear cuenta:', error);
      this.enableCreateAccountButton();
    }
  }

  private async submitCreateAccount(data: any, stepper: MatStepper): Promise<void> {
    const validation = await this.PostValidation.postContalinkValidation(data).toPromise();

    if (validation && validation.code === 'ok') {
      this.applyRehireFlagToSlackPayload(data, validation);
      const uniqueEventId = (crypto as Crypto & { randomUUID(): string }).randomUUID();
      await this.postSlack(data, stepper, uniqueEventId);
      this.pushContactFormSubmittedToDataLayer();
      oaiq("measure", "custom", { type: "custom" }, { custom_event_name: "registro_va" });
      const slackResponse = this.spei_data?.slack_response;
      if (slackResponse?.ok === true) {
        // Mismo id que manda el backend a la Conversions API de OpenAI, para deduplicar
        oaiq("measure", "checkout_started", { type: "contents" },
          { event_id: String(slackResponse.business_partner.cl_business_partner_id) });
      }
      this.dataLayerService.pushEvent('CompleteRegistration', {
        event_id: uniqueEventId,
        ...this.dataLayerService.buildUserData({
          email: this.secondFormGroup.get('email')?.value,
          phone: this.secondFormGroup.get('phone')?.value,
          // ID del business partner en Contalink que regresa /postslack
          externalId: this.spei_data?.slack_response?.business_partner?.cl_business_partner_id,
        }),
      });
      return;
    }

    const reason = (validation && validation.code) ? validation.code : 'validation_failed';
    await this.blockRegistrationAttempt(data, reason);
    this.holdCreateAccountUntilFormChanges();
  }

  // Regresa el paso a un estado editable para que el usuario pueda corregir y reintentar
  private enableCreateAccountButton(): void {
    this.slack_submitted = false;
    this.registrationHoldSnapshot = null;
    this.stepTwoReadMode(false);
    this.processingPayment = false;
  }

  private applyRehireFlagToSlackPayload(data: any, validation: any): void {
    if (validation.data && validation.data.is_rehire === true) {
      data["canceled_deals"] = true;
    }
  }

  private holdCreateAccountUntilFormChanges(): void {
    this.slack_submitted = false;
    this.stepTwoReadMode(false);
    this.processingPayment = false;
    this.registrationHoldSnapshot = this.currentFormSnapshot();
  }

  private currentFormSnapshot(): string {
    if (!this.secondFormGroup) { return ''; }
    return JSON.stringify({
      ...this.secondFormGroup.getRawValue(),
      selectedRegimen: this.selectedRegimen
    });
  }


  private async postSlackMichoacan(data) {
    this.userService.addLogTransaction("post_slack_deal " + (this.secondFormControl.email.value).toLowerCase(), null, this.hashSession)
    let post_slack: any = await this.PostSlack.postContalinkSlack(
      data
    ).toPromise()

    const isExperimentLiteUser: boolean = this.validateExperimentAndLiteUser();
    if (isExperimentLiteUser) { return; }

    if (post_slack['freetrial_result'] && post_slack['freetrial_result']['error'] === true) {
      this.finishMichoacan(
        false,
        'Ya casi, solo un paso más',
        post_slack['freetrial_result']['errorMessage'],
        null
      );
    } else {
      this.finishMichoacan(
        true,
        '',
        '',
        post_slack['freetrial_result']['deal']['onboarding_info']
      );
    }
  }

  private finishMichoacan(post_slack: boolean, errorTitle: string = null, errorSubtitle: string = null, onboarding_agent_info: any = null): void {
    const onboardingAgent = onboarding_agent_info ? onboarding_agent_info['onboardingagent'] : null;
    const email = onboarding_agent_info ? onboarding_agent_info['email'] : null;
    const phone = onboarding_agent_info ? onboarding_agent_info['phone'] : null;

    this.router.navigate(['/listoss'], {
      queryParams: {
        michoacan: true,
        post_slack,
        errorTitle,
        errorSubtitle,
        onboardingagent: onboardingAgent,
        email,
        phone
      }
    });
  }

  async postSlack(data, stepper, uniqueEventId?: string) {
    // Postear Slack con Pipedrive
    this.userService.addLogTransaction("post_slack_deal " + (this.secondFormControl.email.value).toLowerCase(), null, this.hashSession)
    // let post_slack: any;
    let post_slack: any = await this.PostSlack.postContalinkSlack(
      data
    ).toPromise()

    // VALIDA SI ES UN USUARIO LITE CON EXPERIMENTO ACTIVO 
    // const isExperimentLiteUser: boolean = this.validateExperimentAndLiteUser();
    // if (isExperimentLiteUser) { return; }

    if (post_slack['ok'] == true) {
      this.client_secret = post_slack['business_partner']['stripe_clientsecret_id']
      // LandingStepPayment cuando el usuario llena su info y llega al paso M de Pago.
      this.userService.addMixPanelEvent('LandingStepPayment', { status: 'ok' });
      if (this.url_path.includes("//signup.contalink.com") && uniqueEventId) {
        // fbq("trackCustom", "Thank You Page Contacto", {}, { eventID: uniqueEventId });
      }
      /* Acá se carga el formulario de stripe senddata se ejecuta al terminar el segundo paso */
      this.stripe = loadStripe(this.stripe_api_key);
      const options = {
        clientSecret: this.client_secret,
        appearance: {
          variables: {
            colorPrimary: '#2761ad',
            colorText: '#15304e',
            colorTextSecondary: '#63768d',
            colorBackground: '#ffffff',
            colorDanger: '#c75151',
            fontFamily: 'Roboto, Arial, sans-serif',
            fontSizeBase: '14px',
            borderRadius: '8px',
            spacingUnit: '4px',
          },
          rules: {
            '.Input': { border: '1px solid #d7e1ed', boxShadow: 'none', padding: '12px' },
            '.Input:focus': { borderColor: '#2761ad', boxShadow: '0 0 0 3px #2761ad15' },
            '.Label': { color: '#15304e', fontSize: '12px', fontWeight: '500', marginBottom: '8px' },
          },
        },
      };

      this.elements = (await this.stripe).elements(options);
      this.paymentElement = this.elements.create('payment');
      this.paymentElement.mount('#payment-element');
      const form = document.getElementById('payment-form');

      var data_stripe = data
      data_stripe['business_partner_id'] = post_slack['business_partner']['business_partner_id']
      data_stripe['uc_customer_stripe_id'] = post_slack['business_partner']['stripe_customer_id']

      this.userService.addLogTransaction("stripe_form_load", null, this.hashSession)

      this.userService.addLogTransaction(
        "record_landing_write " + post_slack['landing_record']['landing_record_id'],
        post_slack['landing_record']['landing_record_id'], this.hashSession);

      stepper.next()

    } else {
      this.userService.addLogTransaction("stripe_generic_form_error", null, this.hashSession);
      this.userService.addMixPanelEvent('LandingStepThree', { status: 'error', paymentMethod: this.paymentMethod });
      stepper.next()
    }
    this.spei_data = data
    this.spei_data["slack_response"] = post_slack
  }

  goPayment(stepper: MatStepper) {
    if (this.paymentMethod == "card") {
      // LandingStepCard Usuarios que llenana la información y seleccionan método de pago tarjeta
      this.userService.addMixPanelEvent('LandingStepCard', { status: 'ok', paymentMethod: 'card' });
      this.userService.addLogTransaction("card_payment_method_selected", null, this.hashSession);
      this.paymentElement?.on('change', (event) => {
        this.cardInputs = event.complete;
      });
      stepper.next()
    } else {
      // prepare post_spei service
      this.spei_data["business_partner_id"] = this.spei_data["slack_response"]["business_partner"]["cl_business_partner_id"]
      this.spei_data["pipedrive_id"] = this.spei_data["slack_response"]["pipedrive_id"];
      this.userService.addMixPanelEvent('LandingStepThree', { status: 'ok', paymentMethod: this.paymentMethod });

      let post_spei: any = this.PostSpei.postContalinkSpei(this.spei_data).toPromise()
      // this.addLogTransaction("go_back_change_payment_method", null)
      this.userService.addLogTransaction("no_card_payment_method_selected", null, this.hashSession)
      this.goThankYouPage(stepper);
    }
    return false;
  }

  change_payment_method(input) {
    //bank_payment_method - bank_payment_tile
    if (input == "card") this.assignCardPaymentMethodVariables();
    if (input == "spei_oxxo") this.assignSpeiPaymentMethodVariables();
  }

  goStepThree(stepper: MatStepper) {
    this.userService.addLogTransaction("go_back_change_payment_method", null, this.hashSession)
    this.userService.addMixPanelEvent('LandingChangePaymentMethod', { status: 'ok' });
    stepper.selectedIndex = 2;
    stepper.linear = true;
  }

  get signupFormControl() {
    return this.signupForm.controls;
  }

  get secondFormControl() {
    return this.secondFormGroup.controls;
  }

  UpBtn(btn) {
    document.getElementById("btn_next_" + btn).style.backgroundColor = "#92A8D1";
    setTimeout(function () {
      document.getElementById("btn_next_" + btn).style.backgroundColor = "#D7E2EA";
    }, 3000);
  }

  DownBtn(btn) {
    //document.getElementById("btn_next_"+btn).style.backgroundColor = "#92A8D1";
  }

  mobileCheck() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent);
    this.isMobile = check;
  }

  goToStep(step: number, stepper: MatStepper) {
    this.userService.addLogTransaction("go_back_change_payment_method", null, this.hashSession);
    this.userService.addMixPanelEvent('LandingChangePaymentMethod', { status: 'ok' });
    const messageContainer = document.querySelector('#error-message');
    messageContainer.innerHTML = "";
    stepper.selectedIndex = step;
    stepper.linear = true;
  }

  sendPay(stepper: MatStepper) {
    this.pay = true;
    this.finishTransaction();
  }

  closeRFCModal() {
    this.rfcModalService.closeModal();
  }

  // PRIVATE METHODS
  validateCancelTime(): boolean {
    if ((this.check_company!['found_deals']!['cancel'] || 0) >= 1) {
      const monthsCancellation = this.check_company['userCancellationMonths'];

      if (monthsCancellation != null && monthsCancellation < 6) {
        // mostrar mensaje
        this.userService.addMixPanelEvent('LandingTimeNotification', { status: 'ok' });
        this.sweetAlert.showAlertTimeCancellation();
        this.slack_submitted = false;
        this.secondFormGroup.get('rfc').setValue(null);
        this.stepTwoReadMode(false);

        return true;
      } else {
        return false;
      }

    }
  }

  validateProPremPlusUser(): boolean {
    let userPlanLevel: number;
    let isUserAcademy: boolean;
    let userHasDealId: boolean;

    if (this.check_company['userPlan']) {
      userPlanLevel = this.check_company!['userPlan']!['userLevelPlan'];
      isUserAcademy = this.check_company!['userPlan']!['userIsAcademy'] == null ? false : true;
      userHasDealId = this.check_company!['userPlan']!['userHasDealId'] == null ? false : true;
      this.isUserAcademy = isUserAcademy;
    } else {
      return false;
    }

    // SI TIENE ASIGNADO UN DEAL EN UC_DEAL ENTRA AL CONDICIONAL
    if (userHasDealId) {
      if ((userPlanLevel < 1 && userPlanLevel > 3) || this.is_lite || isUserAcademy || this.check_company!['userPlan']['despacho_id'] == 18712) {
        return false;
      } else {
        // VALIDAR LO SIGUIENTE
        this.showProPremiumPlusModal();
        this.slack_submitted = false;
        this.secondFormGroup.get('email').setValue(null);
        this.stepTwoReadMode(false);

        return true;
      }
    } else {
      return false;
    }
  }

  private async validateRfcLite(data: any): Promise<boolean> {
    if (this.check_company['found_companies'] > 0 && !this.is_lite) {
      if (this.check_company['is_rfc_lite']) {
        this.stepTwoReadMode(false);
        this.slack_submitted = false;
        data["rfc_lite"] = true;
        this.userService.addLogTransaction("validation_rfc_lite", null, this.hashSession);
        await this.blockRegistrationAttempt(data, "rfc_lite");

        return true;
      } else {
        this.secondFormGroup.get('rfc_invoicing').setValue(null);
        this.secondFormGroup.get('rfc').setValue(null);
        if ((this.check_company['found_deals']['active'] || 0) > 0) {
          this.userService.addMixPanelEvent('LandingCSNotification', { status: 'ok' });
          data["rfc_exists"] = true
          data["active_deals"] = true
          this.slack_submitted = false
          this.userService.addLogTransaction("validation_existing_tax_id", null, this.hashSession)
          this.stepTwoReadMode(false);
          await this.blockRegistrationAttempt(data, "existing_tax_id");

          return true;
        } else {
          // Encontró un deal cancelado
          data["canceled_deals"] = true
        }
      }
      /*
      data["rfc_exists"] = true
      this.stepTwoReadMode(false)
      this.slack_submitted = false
      this.addLogTransaction("validation_existing_tax_id", null)
      */
    }

    return false;
  }

  private async validateAcademyUser(data: any): Promise<boolean> {
    if (!this.isUserAcademy) { return false; }

    this.stepTwoReadMode(false);
    this.slack_submitted = false;
    this.userService.addLogTransaction("validation_academy_user", null, this.hashSession);
    await this.blockRegistrationAttempt(data, "academy_user");

    return true;
  }

  private async validateEmailExist(data: any) {
    if (this.check_company['found_users'] > 0) {
      this.stepTwoReadMode(false)
      this.slack_submitted = false
      this.userService.addLogTransaction("validation_existing_user", null, this.hashSession);
      this.stepTwoCompleted = false;
      await this.blockRegistrationAttempt(data, "existing_user");

      return false;
    }
    return true;
  }

  // Deja registro del intento vía postSlack y avisa al usuario que no puede continuar por este medio
  private async blockRegistrationAttempt(data: any, reason: string): Promise<void> {
    try {
      data["blocked_registration"] = reason;
      await this.PostSlack.postContalinkSlack(data).toPromise();
    } catch (error) {
      console.error('Error al registrar el intento bloqueado:', error);
    }

    await this.sweetAlert.showAlertRegistrationBlocked();
  }

  private validateExistRfc(data: any): boolean {
    if (this.check_company['found_bpartner'] && !this.is_lite) {
      if ((this.check_company['found_deals']['bp_active'] || 0) > 0) {
        this.userService.addMixPanelEvent('LandingCSNotification', { status: 'ok' });
        this.secondFormGroup.get('rfc_invoicing').setValue(null);
        this.secondFormGroup.get('rfc').setValue(null);
        //alert("En Contalink ya existe un Cliente con este RFC, cambie el RFC de facturación o en breve nos contactaremos con usted o puede escribirnos a info@contalink.com")
        data["partner_exists"] = true
        this.stepTwoReadMode(false)
        this.slack_submitted = false
        this.userService.addLogTransaction("validation_existing_partner", null, this.hashSession);
        this.obAgentName = this.check_company['found_deals']['obagent_name'];
        this.obAgentEmail = this.check_company['found_deals']['obagent_email'];
        this.obAgentPhone = this.check_company['found_deals']['obagent_phone'];
        this.openRFCModal("partner", null);
        this.stepTwoReadMode(false);
        return true;
      }
    }
    return false;
  }

  private async validateExperimentAndAcademyUser(data): Promise<boolean> {
    if (
      this.check_company &&
      this.check_company['userPlan'] &&
      this.check_company['userPlan']['userIsAcademy'] !== null &&
      (this.stateName === 'Yucatán' || this.stateName === 'Michoacán')
    ) {

      // POST SLACK PARA CREAR EL USUARIO DE ACADEMIA
      this.userService.addLogTransaction("post_slack_deal " + this.secondFormControl.email.value, null, this.hashSession)
      data['userIsAcademy'] = true;
      let post_slack: any = await this.PostSlack.postContalinkSlack(
        data
      ).toPromise()

      this.finishMichoacan(
        false,
        'Ya casi, solo un paso más',
        `Tu correo tiene acceso a Academia Contalink, para convertirlo a usuario un asesor se comunicará contigo. 
         Para cualquier duda puedes escribirnos a info@contalink.com o por Whatsapp al 811 910 7569`,
        null
      );

      return true;
    }
    return false;
  }

  private validateExperimentAndLiteUser(): boolean {
    if (this.is_lite &&
      (this.stateName === 'Yucatán' || this.stateName === 'Michoacán')) {
      this.finishMichoacan(
        false,
        'Ya casi, solo un paso más',
        `Tu correo tiene acceso a Academia Contalink, para convertirlo a usuario un asesor se comunicará contigo. 
        Para cualquier duda puedes escribirnos a info@contalink.com o por Whatsapp al 811 910 7569`,
        null
      );

      return true;
    }

    return false;
  }

  private async validateAllConditions(data, stepper = null) {
    await this.validateUserAttempts();
    await this.valiteUserAcademy();

    // USUARIO CON CORREO DE ACADEMIA CONTALINK
    const isAcademyUser: boolean = await this.validateAcademyUser(data);
    if (isAcademyUser) { this.enableCreateAccountButton(); return; }

    // // CORREO USUARIO EXISTENTE
    const isEmailExist: boolean = await this.validateEmailExist(data);
    if (!isEmailExist) { this.enableCreateAccountButton(); return; }

    // VALIDA SI ES UN USUARIO ACADEMIA CON EXPERIMENTO ACTIVO
    const isExperimentAcademyUser: boolean = await this.validateExperimentAndAcademyUser(data);
    if (isExperimentAcademyUser) { this.processingPayment = false; return; }

    // VALIDA SI EL USUARIO ESTA EN UN DEAL ACTIVO PRO, PLUS O PREMIUM
    const isProPremPlus: boolean = await this.validateProPremPlusUser();
    if (isProPremPlus) { this.processingPayment = false; return; }

    const isTimeLessThanSixMonths: boolean = await this.validateCancelTime();
    if (isTimeLessThanSixMonths) { this.processingPayment = false; return; }

    // // VALIDAR SI EL RFC ES GENERICO
    const isRfcGenric: boolean = this.validateGenericRFC(this.secondFormGroup.get('rfc').value, data);
    if (isRfcGenric) { this.processingPayment = false; return; }

    // // EXISTE UN CLIENTE ES CONTALINK CON ESE RFC
    const isRfcExist: boolean = this.validateExistRfc(data);
    if (isRfcExist) { this.processingPayment = false; return; }

    // // RFC CORRESPONDE A UNA CUENTA LITE
    const isRfcLite: boolean = await this.validateRfcLite(data);
    if (isRfcLite) { this.enableCreateAccountButton(); return; }

    if (this.check_company['is_rfc_lite']) {
      // El correo no existe en Contalink pero el rfc ingresado existe y es lite
      // alert("El RFC ingresado corresponde a una cuenta Lite, ingresa el correo electrónico asociado a dicha cuenta para continuar.")
      this.enableCreateAccountButton();
      return;
    }

    let advanced = false;

    if (this.check_company['found_users'] <= 0) {
      // SI EL ESTADO ES MICHOACAN STEPPER LLEGA NULL Y SE MANDA EL POSTSLACK DIFERENTE
      if (stepper == null) {
        this.userService.addLogTransaction("post_slack_no_deal " + this.secondFormControl.email.value, null, this.hashSession);
        await this.postSlackMichoacan(data);
      } else {
        //registrar el deal y slack sólo si no existe como usuario
        this.userService.addLogTransaction("post_slack_no_deal " + this.secondFormControl.email.value, null, this.hashSession);
        await this.postSlack(data, stepper);
      }
      advanced = true;
    }
    if (this.emailCodeCorrect) {
      if (stepper == null) {
        await this.postSlackMichoacan(data);
      } else {
        await this.postSlack(data, stepper);
      }
      advanced = true;
    }

    // Si ninguna ruta avanzó al siguiente paso, se rehabilita el botón para no dejar al usuario atorado
    if (!advanced) {
      this.enableCreateAccountButton();
    }
  }

  private validateUserAttempts(): void {
    if (this.check_company['user_attempts'] >= 1) {
      this.sweetAlert.showAlertUserAttempts();
    }
  }

  private validateGenericRFC(rfc: string, data: any): boolean {
    if (rfc != "XAXX010101000") { return false; }
    this.sweetAlert.showAlertGenericRFC();
    data["rfc_generico"] = true;
    this.stepTwoReadMode(false);
    this.slack_submitted = false;
    this.userService.addLogTransaction("validation_generic_tax_id", null, this.hashSession);
    this.stepTwoCompleted = false;

    return true;
  }

  // Fill all values from FormGroup in Data variable
  private fillDataValues(): any {
    this.formatter = new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2
    });

    const qa_env: boolean = (this._env != 'prod') ? true : false;

    return this.userService.fillDataValues(
      this.secondFormControl, qa_env, this.planInformation.number_of_users, (this.planInformation.id).toString(), (this.planInformation.recurrence).toString(),
      this.formatter.format(this.planInformation.total_sale).toString(), this.formatter.format(this.planInformation.discount).toString(), this.selectedRegimenName, this.selectedRegimen,
      this.selectedFuente, this.pipedriveReference, this.planInformation.price, this.planInformation.discount_deal, this.utm_medium,
      this.utm_source, this.utm_campaign, this.fbclid, this.gclid, this.ttclid, this.utm_id, this.version,
      this.utm_term, this.utm_content, this.ad_set, this.first_utm, this.first_visit_date, this.lite_code, this.referred_id,
      this.referredEmail, this.planInformation.half_off_discount, this.planInformation.volumen_discount_percentage, this.planInformation.annual_discount_percentage,
      this.planInformation.volumen_discount_amount, this.planInformation.annual_discount_amount,
      this.assignEmailPromotional(this.acceptedPromotionalEmail), Number(this.planInformation.welcome_discount_percentage), this.free_trial,
      this.planInformation.potential_user_number, this.selectLineOfBusinessId, this.isUserAcademy, this.posthog_id,
      this.planInformation.base_rfcs
    );
  }

  private assignCardPaymentMethodVariables(): void {
    let check_pm;
    if (this.paymentMethod == "card") {
      // deseleccionar card
      this.paymentMethod = null;
      check_pm = document.getElementById("card_payment_method") as HTMLInputElement;
      check_pm.checked = false;
      document.getElementById("card_payment_tile").style.backgroundColor = 'transparent';
      check_pm = document.getElementById("card_payment_method") as HTMLInputElement;
      check_pm.checked = false;
      this.showPendiente = false;
    } else {
      //seleccionar card
      this.paymentMethod = "card";
      document.getElementById("card_payment_tile").style.backgroundColor = '#A2E4F5';
      document.getElementById("spei_oxxo_payment_title").style.backgroundColor = 'transparent';

      check_pm = document.getElementById("card_payment_method") as HTMLInputElement;
      check_pm.checked = true;
      check_pm = document.getElementById("spei_oxxo_payment_method") as HTMLInputElement;
      check_pm.checked = false;
      this.showPendiente = false;
    }
  }

  private assignSpeiPaymentMethodVariables(): void {
    let check_pm;
    if (this.paymentMethod == "spei_oxxo") {
      // deseleccionar bank
      this.paymentMethod = null;
      document.getElementById("spei_oxxo_payment_method").style.backgroundColor = 'transparent';
      check_pm = document.getElementById("spei_oxxo_payment_method") as HTMLInputElement;
      check_pm.checked = false;
      this.showPendiente = true;
    } else {
      //seleccionar bank
      this.paymentMethod = "spei_oxxo";
      document.getElementById("card_payment_tile").style.backgroundColor = 'transparent';
      document.getElementById("spei_oxxo_payment_title").style.backgroundColor = '#A2E4F5';
      check_pm = document.getElementById("card_payment_method") as HTMLInputElement;
      check_pm.checked = false;

      check_pm = document.getElementById("spei_oxxo_payment_method") as HTMLInputElement;
      check_pm.checked = true;
      this.showPendiente = true;
    }
  }

  private async valiteUserAcademy(): Promise<void> {
    // Se reasigna siempre: si no se limpia, un intento previo con correo de Academia
    // deja la bandera encendida y bloquea al usuario aunque corrija el correo
    this.isUserAcademy = this.check_company['userPlan']
      ? this.check_company['userPlan']['userIsAcademy'] != null
      : false;
  }

  private async finishTransaction() {
    if (this.pay) {
      const errorStripe = (await this.stripe).confirmSetup({
        elements: this.elements,
        confirmParams: {
          return_url: `${environment[this._env]['url']}/listoss`,
        }
      }).then((data) => {
        if (data.hasOwnProperty("error")) {
          if (data.error.hasOwnProperty("message")) {
            let errorMessagePopUp = JSON.stringify(data.error.message) || "No hemos podido procesar tu pago por rechazo del banco. <br>Favor de contactarte con tu banco para solicitar la autorización de esta transacción.<br> Una vez que contactes con tu banco, da click en “Volver” para reintentar el pago. ";
            const messageContainer = document.querySelector('#error-message');
            //alert(errorMessagePopUp);
            this.userService.addLogTransaction("stripe_form_error " + errorMessagePopUp.replace(/^"|"$/g, ''), null, this.hashSession)
            messageContainer.innerHTML = '<p style="color:#DF1B41;">' + errorMessagePopUp.replace(/^"|"$/g, '') + '</p>';
          }
        }
      });
    }
  }

  private seeStepTwoDownForm() {
    if (!this.isMobile) {
      window.scroll(0, 200)
    }
  }

  private validateSecondFormInputs(field: any): void {
    if (field == "phone") {
      this.secondFormGroup.get('phone').setValue(this.secondFormGroup.get('phone').value.replace(/\D/g, ''));

      if (this.secondFormGroup.get('phone').value.length != 10) {
        this.textToolTipPhone = "El número de tener 10 dígitos"
        this.renderer.setStyle(this.phoneElement.nativeElement, 'textDecoration', 'underline dashed #F08080');
      } else {
        this.textToolTipPhone = "El número es correcto"
        this.renderer.setStyle(this.phoneElement.nativeElement, 'textDecoration', 'none');
      }
    }

    if (field == "email") {
      this.secondFormGroup.get('username').setValue(this.secondFormGroup.get('email').value)
      if (this.secondFormGroup.get('email').invalid) {
        this.renderer.setStyle(this.emailElement.nativeElement, 'textDecoration', 'underline dashed #F08080');
      } else {
        this.renderer.setStyle(this.emailElement.nativeElement, 'textDecoration', 'none');
      }
    }

    if (field == "rfc") {
      this.secondFormGroup.get('rfc').setValue(this.secondFormGroup.get('rfc').value.toUpperCase());
      if (this.secondFormGroup.get('rfc').invalid) {
        this.renderer.setStyle(this.rfcElement.nativeElement, 'textDecoration', 'underline dashed #F08080');
      } else {
        this.renderer.setStyle(this.rfcElement.nativeElement, 'textDecoration', 'none');
      }
    }
    if (field == "postal_code") {
      this.secondFormGroup.get('postal_code').setValue(this.secondFormGroup.get('postal_code').value.replace(/\D/g, ''));
    }
  }

  private seeStepTwoNextButton() {
    if (!this.isMobile) {
      window.scroll(0, 300)
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }

  private changeTitlePlanStyle(heightPercent: string, titlePlan: string, colorTitle: string): void {
    this.renderer.setStyle(this.descriptionPlanInfoElement.nativeElement, 'height', `${heightPercent}`);
    this.renderer.setProperty(this.titlePlanElement.nativeElement, 'innerHTML', `${titlePlan}`);
    this.renderer.setStyle(this.titlePlanElement.nativeElement, 'color', `${colorTitle}`);
    this.renderer.setProperty(this.typePlanElement.nativeElement, 'innerHTML', `${titlePlan}`);
  }

  private assignCookieVariables(): void {
    const { utm_medium, utm_source, utm_campaign, utm_content, utm_term, ad_set, first_utm, first_visit_date, fbclid, gclid, ttclid, utm_id, version, posthog_id } = this.cookiesService.getAllCookies()
    this.utm_medium = utm_medium
    this.utm_source = utm_source
    this.utm_campaign = utm_campaign
    this.utm_content = utm_content
    this.utm_term = utm_term
    this.ad_set = ad_set
    this.first_utm = first_utm
    this.first_visit_date = first_visit_date
    this.fbclid = fbclid
    this.gclid = gclid
    this.ttclid = ttclid
    this.utm_id = utm_id
    this.version = version
    this.posthog_id = posthog_id
  }

  private validateUserAndPasswordInLite(): void {
    if (this.lite_code != null && this.lite_code != undefined) {
      this.secondFormGroup.get('email').disable();
      this.secondFormGroup.get('userpass').disable();
      this.secondFormGroup.get('username').disable();
    }
  }

  private assignStripeApiKeyFromEnvironment(): void {
    this.stripe_api_key = environment[this._env]['STRIP_API_KEY_LIVE'];
  }

  private assignStepperStyles(): void {
    let testElements = Array.from(document.getElementsByClassName('mat-horizontal-stepper-header-container') as HTMLCollectionOf<HTMLElement>)
    testElements.forEach((element) => { element.style.pointerEvents = 'none'; });

    let stepperBars = Array.from(document.getElementsByClassName('mat-horizontal-stepper-header-container') as HTMLCollectionOf<HTMLElement>)
    stepperBars.forEach((stepperBar) => {
      if (this.isMobile) stepperBar.style.display = 'none';
      else stepperBar.style.height = '25px';
    });

    let matHorizontal = Array.from(document.getElementsByClassName('mat-horizontal-content-container') as HTMLCollectionOf<HTMLElement>)
    matHorizontal.forEach((matHzt) => { if (this.isMobile) matHzt.style.padding = '0'; });

    let stepperIcons = Array.from(document.getElementsByClassName('mat-step-icon') as HTMLCollectionOf<HTMLElement>)
    stepperIcons.forEach((stepperIcon) => { stepperIcon.style.backgroundColor = 'green'; });
  }

  private buildSecondFormGroup(): FormGroup {
    return this._formBuilder.group({
      name: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$")]],
      username: ['', Validators.required],
      userpass: ['', Validators.nullValidator],
      company: ['', Validators.required],
      rfc: ['', [Validators.required, Validators.pattern("^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z0-9]{3}")]],
      company_invoicing: ['', [Validators.required, Validators.nullValidator]],
      rfc_invoicing: ['', [Validators.required, Validators.nullValidator, Validators.pattern("^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z0-9]{3}")]],
      use_same_data_for_invoicing: ['', Validators.required],
      regimen_fiscal: ['', Validators.required],
      fuente: ['', Validators.required],
      postal_code: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{5}$")]]
    });
  }

  private async goThankYouPage(stepper: MatStepper) {
    stepper.selectedIndex = 5;
    stepper.linear = true;
  }

  private openRFCModal(entity: string, rfc: string) {
    this.rfcModalService.openModal({
      "entity": entity,
      "obAgentName": this.obAgentName,
      "obAgentEmail": this.obAgentEmail,
      "obAgentPhone": this.obAgentPhone,
      "emailInput": this.secondFormControl.email.value,
      "rfcInput": rfc
    });
  }

  // Verificación por código para usuarios existentes. Sin uso mientras el correo existente se bloquea
  // en validateEmailExist; se conserva para reactivar el mecanismo.
  private async validateExistsEmail() {
    const response = await this.sweetAlert.codeSweetAlert(this.secondFormGroup.get('email').value.toLowerCase());
    return response;
  }

  private saveAttributionCookiesFromParams() {
    this.route.queryParams.subscribe((params) => {
      const { utm_medium, utm_source, utm_term,ad_set, utm_content, utm_campaign, lite, fbclid, gclid, ttclid, utm_id, version, posthog_id } = params;
      if (lite) this.lite_code = lite

      //   Set UTM Cookies to most recent data
      if (utm_medium) this.cookiesService.createCookie('utm_medium', utm_medium, this.COOKIES_EXPIRATON_DAYS);
      if (utm_source) this.cookiesService.createCookie('utm_source', utm_source, this.COOKIES_EXPIRATON_DAYS);
      if (utm_campaign) this.cookiesService.createCookie('utm_campaign', utm_campaign, this.COOKIES_EXPIRATON_DAYS);
      if (ad_set) this.cookiesService.createCookie('ad_set', ad_set, this.COOKIES_EXPIRATON_DAYS);
      if (utm_term) this.cookiesService.createCookie('utm_term', utm_term, this.COOKIES_EXPIRATON_DAYS);
      if (utm_content) this.cookiesService.createCookie('utm_content', utm_content, this.COOKIES_EXPIRATON_DAYS);
      if (fbclid) this.cookiesService.createCookie('fbclid', fbclid, this.COOKIES_EXPIRATON_DAYS);
      if (gclid) this.cookiesService.createCookie('gclid', gclid, this.COOKIES_EXPIRATON_DAYS);
      if (ttclid) this.cookiesService.createCookie('ttclid', ttclid, this.COOKIES_EXPIRATON_DAYS);
      if (utm_id) this.cookiesService.createCookie('utm_id', utm_id, this.COOKIES_EXPIRATON_DAYS);
      if (version) this.cookiesService.createCookie('version', version, this.COOKIES_EXPIRATON_DAYS);
      if (posthog_id) this.cookiesService.createCookie('posthog_id', posthog_id, this.COOKIES_EXPIRATON_DAYS);

      //   If isn't the first time user visit Contalink, then keeps the UTM data of where the user comes
      if (this.cookiesService.readCookie('first_utm') == '') {
        let first_utm = '';
        if (utm_medium) first_utm += `Medium: ${utm_medium} - `;
        if (utm_source) first_utm += `Source: ${utm_source} - `;
        if (utm_campaign) first_utm += `Campaign: ${utm_campaign} - `;
        if (utm_term) first_utm += `Term: ${utm_term} - `;
        if (utm_content) first_utm += `Content: ${utm_content} - `;
        if (fbclid) first_utm += `fbclid: ${fbclid} - `;
        if (gclid) first_utm += `gclid: ${gclid} - `;
        if (ttclid) first_utm += `ttclid: ${ttclid} - `;
        if (ad_set) first_utm += `ADSet: ${ad_set} - `;
        this.cookiesService.createCookie('first_utm', first_utm, this.COOKIES_EXPIRATON_DAYS);
      }

      // Also keep the date user's first visit
      if (!this.cookiesService.readCookie('first_visit_date')) {
        const date = new Date();

        this.cookiesService.createCookie(
          'first_visit_date',
          `${date.toLocaleString()}`,
          this.COOKIES_EXPIRATON_DAYS
        );
      }
    });
  }

  changeAcceptedPromotionalEmail(): void {
    if (this.acceptedPromotionalEmail) this.acceptedPromotionalEmail = false;
    else this.acceptedPromotionalEmail = true;
  }

  private assignEmailPromotional(emailPromotional: boolean): number {
    if (emailPromotional) return 540;
    else return 541;
  }

  private showProPremiumPlusModal(): void {
    this.sweetAlert.showAlertProPremPlus();
  }

  assignPlanFromStepOne(plan: IPlanInfo | null): void {
    this.planSelectionReady = !!plan;
    if (plan) this.planInformation = plan;
  }


  pushContactFormSubmittedToDataLayer(): void {
    this.syncGtmContactLocalStorageFromForm();

    const email = window.localStorage.getItem(UsersComponent.GTM_FORM_EMAIL_KEY) || '';
    const phone = window.localStorage.getItem(UsersComponent.GTM_FORM_PHONE_KEY) || '';
    const name = window.localStorage.getItem(UsersComponent.GTM_FORM_NAME_KEY) || '';

    const w = window as unknown as { dataLayer?: Record<string, unknown>[] };
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      event: 'thank_you_page_contact_form_submitted',
      user_data: {
        email: this.hashGtmContactEmail(email),
        phone: this.hashGtmContactPhone(phone),
        name: this.hashGtmContactName(name),
      }
    });
    this.scheduleGtmContactCleanup();
  }

  sendMetaAPIEvent(event_name: string, uniqueEventId?: string) {
    let $metaApi: Observable<any> = this.sendFormContactService.sendIntegrationAPI(event_name, uniqueEventId)

    $metaApi.subscribe(() => {})
  }

  private showRfcNonFoundModal(): void {
    this.sweetAlert.showAlertRfcNotFound();
  }


  private syncGtmContactLocalStorageFromForm(): void {
    if (!this.secondFormGroup) return;

    this.setGtmContactLocalStorage(
      this.secondFormGroup.get('email')?.value || '',
      this.secondFormGroup.get('phone')?.value || '',
      this.secondFormGroup.get('name')?.value || ''
    );
  }

  private setGtmContactLocalStorage(email: string, phone: string, name: string): void {
    try {
      const entries: [string, string][] = [
        [UsersComponent.GTM_FORM_EMAIL_KEY, email.trim().toLowerCase()],
        [UsersComponent.GTM_FORM_PHONE_KEY, phone.replace(/\D/g, '')],
        [UsersComponent.GTM_FORM_NAME_KEY, name.trim()],
      ];

      entries.forEach(([key, value]) => {
        if (value) localStorage.setItem(key, value);
        else localStorage.removeItem(key);
      });
    } catch {
      /* storage no disponible */
    }
  }

  private hashGtmContactEmail(email: string): string | undefined {
    const normalized = email.trim().toLowerCase();
    return normalized ? SHA256(normalized).toString() : undefined;
  }

  private hashGtmContactPhone(phone: string): string | undefined {
    const normalized = phone.replace(/\D/g, '');
    return normalized ? SHA256(normalized).toString() : undefined;
  }

  private hashGtmContactName(name: string): string | undefined {
    const normalized = name.trim().toLowerCase();
    return normalized ? SHA256(normalized).toString() : undefined;
  }

  private clearGtmContactLocalStorage(): void {
    try {
      localStorage.removeItem(UsersComponent.GTM_FORM_EMAIL_KEY);
      localStorage.removeItem(UsersComponent.GTM_FORM_PHONE_KEY);
      localStorage.removeItem(UsersComponent.GTM_FORM_NAME_KEY);
    } catch {
      /* ignore */
    }
  }

  private clearGtmContactDataLayer(): void {
    const w = window as unknown as { dataLayer?: Record<string, unknown>[] };
    w.dataLayer = w.dataLayer || [];

    w.dataLayer.push({
      event: 'gtm_contact_form_data_cleared',
      user_data: {
        email: undefined,
        phone: undefined,
        name: undefined,
      },
    });
  }

  private scheduleGtmContactCleanup(): void {
    this.cancelGtmContactCleanupSchedule();
    this.gtmContactStorageClearHandle = window.setTimeout(() => {
      this.gtmContactStorageClearHandle = null;
      this.clearGtmContactLocalStorage();
      this.clearGtmContactDataLayer();
    }, UsersComponent.GTM_CONTACT_STORAGE_CLEAR_MS);
  }

  private cancelGtmContactCleanupSchedule(): void {
    if (this.gtmContactStorageClearHandle != null) {
      clearTimeout(this.gtmContactStorageClearHandle);
      this.gtmContactStorageClearHandle = null;
    }
  }

  ngOnDestroy(): void {
    this.cancelGtmContactCleanupSchedule();
    this.clearGtmContactLocalStorage();
  }


  private setLocalStorageUserData(checkIdInfo: any): void {
    try {
      if (this.secondFormGroup) {
        localStorage.setItem('user_email', this.secondFormGroup.get('email')?.value?.toLowerCase());
        localStorage.setItem('user_phone', this.secondFormGroup.get('phone')?.value);
        localStorage.setItem('user_name', checkIdInfo['name']);
        localStorage.setItem('user_secondNames', checkIdInfo['secondNames']);
        localStorage.setItem('user_state', checkIdInfo['state']);
        localStorage.setItem('user_city', checkIdInfo['city']);
        localStorage.setItem('user_postalCode', checkIdInfo['postalCode']);
        localStorage.setItem('user_birthDay', checkIdInfo['birthDay']);
      }
    } catch (error) {
      console.warn('Error in setLocalStorageUserData:', error);
    }
  }

  private checkIdToMetaData(rfc: string): void {
    if (!rfc || rfc.length <= 11) return;

    this.checkIdService.getRfcInformation(rfc)
      .pipe(
        debounceTime(1500),
        catchError(error => {
          console.error('Error en la petición a checkId:', error);
          return of(null);
        })
      )
      .subscribe(response => {
        if (!response || !response['checkId'] || response['checkId']['exitoso'] == false) return;

        let data = response['checkId']['resultado'];
        const checkIdInfo: any = {
          "postalCode": data.codigoPostal?.codigoPostal || '',
          "birthDay": data.curp?.fechaNacimientoText || '',
          "name": data.curp?.nombres || '',
          "secondNames": `${data.curp?.primerApellido || ''} ${data.curp?.segundoApellido || ''}`.trim(),
          "state": data.curp?.entidad || '',
          "city": data.curp?.municipioRegistro || ''
        }

        // Set user values to PIXEL API
        this.setLocalStorageUserData(checkIdInfo);
      });
  }
}
